import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type LocaleState = {
  locale: string;
  setLocale: (code: string) => void;
};

/**
 * Admin UI active locale — separate from auth store since logging out should
 * not reset the locale preference. Default is 'en'; seed locales are en/lt/uk.
 */
export const useLocaleStore = create<LocaleState>()(
  persist(
    (set) => ({
      locale: 'en',
      setLocale: (code) => set({ locale: code }),
    }),
    { name: 'reform-lite-locale' },
  ),
);
